module.exports = __webpack_public_path__ + "static/media/Group 7006.9910da44.svg";